import React from 'react'
import CustomTable from '../../shared/CustomTable'

function PolicyLevelTable () {
  return (
    <div>
      <CustomTable
        headers={[
          'Policy Number',
          'Policy Holder',
          'Payer',
          'Effective Date',
          'End Date'
        ]}
        // rows={[{ Name: 'John Doe', Age: 28, Location: 'New York' }]}
      />
    </div>
  )
}

export default PolicyLevelTable
